import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import 'assets/scss/styles.scss?v=1.5.0';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);
